import { css } from '@emotion/react';
export const GlobalStyles = css`
  html {
    scroll-behavior: smooth;
  }
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
    box-shadow: none;
  }

  @font-face {
    font-family: 'Basier-Circle';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/fonts/fonnts.com-BasierCircle-Regular.otf') format('opentype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: 'Futura';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('/fonts/futura-std-4/FuturaStdLight.otf') format('opentype');
  }

  @font-face {
    font-family: 'Futura';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/fonts/futura-std-4/FuturaStdBook.otf') format('opentype');
  }

  @font-face {
    font-family: 'Futura';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('/fonts/futura-std-4/FuturaStdMedium.otf') format('opentype');
  }

  @font-face {
    font-family: 'Futura';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('/fonts/futura-std-4/FuturaStdBold.otf') format('opentype');
  }

  @font-face {
    font-family: 'Futura';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('/fonts/futura-std-4/FuturaStdExtraBold.otf') format('opentype');
  }

  
  body {
    font-size: 12px;
    font-family: 'Basier-Circle', sans-serif;
  }
  .phone-input-container {
    height: 43px;
    width: 100% !important;
  }
  .phone-input-field {
    height: 100% !important;
    width: 100% !important;
  }

  .phone-input-button {
    background-color: transparent !important;
  }

  .phone-input-search input {
    border: none !important;
  }
  .star-rating-container > *:not(:last-child) {
    margin-right: 30px;
  }
  .custom-modal::-webkit-scrollbar {
    display: none;
  }
  .modal-text {
    color: #121B26;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: .5rem;
  }

  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none; 
  }

  .no-scrollbar::-webkit-scrollbar {
    width: 0px;
  }
  .no-scrollbar::-webkit-scrollbar-thumb {
    display: none;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 0px;
    background-color: #FFEFEF;
  }
  
  ::-webkit-scrollbar-thumb {
    background-color: #FF6F61;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background-color: #FF6F61;
  }
`;
